var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Section1Widget',{attrs:{"to":"/"}}),(!_vm.top_categories)?_c('b-spinner',{attrs:{"variant":"secondary"}}):_vm._e(),_vm._l((_vm.top_categories),function(c){return _c('CategoryInfo',{key:c.id,attrs:{"category":c}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }